import { Injectable, Inject,} from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository,Raw, getConnection } from 'typeorm';
import { AllWelfareResponseModel, WelfareidstatusResponseModel, WelfareResponseModel, WelfarestatusupdateResponseModel, WelfareupdatestatusResponseModel } from './dto/welfare-response-model';
import { WelfareEntity } from './welfare.entity';
import { WelfareStatusWiseResponseModel} from './dto/welfare-status-response.model';
import { WelfareDTO, WelfareidstatusDTO, WelfareStatusDTO } from './dto/welfare.dto';
import { WelfareStatusEntity } from '../welfarestatus/welfarestatus.entity';





@Injectable()
export class WelfareService {
    constructor(
        @InjectRepository(WelfareEntity)
        private welfareRepository: Repository<WelfareEntity>,
        @InjectRepository(WelfareStatusEntity)
        private welfarestatusRepository: Repository<WelfareStatusEntity>
    ) {}
    async createWelfare(queryParams, WelfareDTO:WelfareDTO) {
      try {
       
         const WelfareExist = await this.getWelfareDetailsWithoutRelations(WelfareDTO.mobileNo);
         if (WelfareExist) {
           throw new ErrorResponse(11104, 'Welfare already exists');
         } else {
          if(queryParams.apiVersion == 1) {
              const savedPost = await this.welfareRepository.save(WelfareDTO);
              if(savedPost) {
                  return savedPost;
              } else {
                  return null;
              }
          } else {
              const savedPost = await this.welfareRepository.save(WelfareDTO);
              if(savedPost) {
                  return savedPost;
              } else {
                  return null;
              }
          }
        }
      } catch (error) {
          throw error;
      
  }
    }
    async createWelfarestatus(queryParams,filesData,statusId): Promise<WelfareidstatusResponseModel> {
   
      const response = new WelfareidstatusResponseModel();
      try {
              if(queryParams.apiVersion == 1) {
               
                const savedWelfare = await this.welfarestatusRepository.save(filesData);
                
                  const updatedData = await this.welfareRepository.find({
                      relations:['welfarestatus','welfaretype'],
                      where:{Id:statusId}
                  });
                  if (savedWelfare) {
                    response.status = true;
                    response.data = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Welfare created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Welfare not created');
                  }
                } else {
                  const savedWelfare = await this.welfarestatusRepository.save(filesData);
                
                  const updatedData = await this.welfareRepository.find({
                      relations:['welfarestatus','welfaretype'],
                      where:{Id:statusId}
                  });
                  if (savedWelfare) {
                    response.status = true;
                    response.data = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Welfare created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Welfare not created');
                  }
              }
          
          return response;
      }
     
      catch (error) {
          throw error;
      }
  
    }  
  

 
  async getWelfareDetailsWithoutRelations(mobileNo): Promise<WelfareEntity> {
    const WelfareResponse = await this.welfareRepository.findOne({
      where: { mobileNo:mobileNo, status: true },
    });
    if (WelfareResponse) {
      console.log(WelfareResponse,"relations")
      return WelfareResponse;
    } else {
      return null;
    }
  }



  async updateWelfare(queryParams, WelfareDTO: WelfareDTO, request:Request): Promise<WelfareidstatusResponseModel> {
    const response = new WelfareidstatusResponseModel();
    console.log(WelfareDTO,"data")
    try {
        if(queryParams.apiVersion == 1) {
            const updatePostType = await this.welfareRepository.update(WelfareDTO.Id, WelfareDTO);
          
           
            const updatedData = await this.welfareRepository.find({
              relations:['welfarestatus','welfaretype'],
              where:{Id:WelfareDTO.Id}
          });
            if(updatePostType) {
                response.status = true;
                response.data = updatedData;
                response.statusCode = 50000;
                response.internalMessage = 'welfare details updated successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'welfare details Update Failed')
            }
        } else {
          const updatePostType = await this.welfareRepository.update(WelfareDTO.Id, WelfareDTO);
console.log(updatePostType)
         
          const updatedData = await this.welfareRepository.find({
            relations:['welfarestatus','welfaretype'],
            where:{Id:WelfareDTO.Id}
        });
          if(updatePostType) {
              response.status = true;
              response.data = updatedData;
              response.statusCode = 50000;
              response.internalMessage = 'welfare details updated successfully';
              response.intlCode = 11108;
          } else {
              throw new ErrorResponse(99998, 'welfare details Update Failed')
          }
        }
        return response;
    } catch (error) {
        throw error;
    }

    
}







  async getAllWelfare(queryParams, request:Request): Promise<AllWelfareResponseModel>{
    const response = new AllWelfareResponseModel();
    try{
      if (queryParams.apiVersion == 1) {
        const welfare = await this.welfareRepository.find({
          relations:['welfarestatus','welfaretype'],
          where: {status: true},
                    order: { createdAt: 'DESC' }
        });
        if(welfare){
          response.status = true;
          response.data = welfare;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998,'Data not found');
        }
      } else {
        const welfare = await this.welfareRepository.find({
          relations:['welfarestatus','welfaretype'],
          where: {status: true},
          order: { createdAt: 'DESC' }
        });
        if(welfare){
          response.status = true;
          response.data = welfare;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse (99998, 'Data not found');
        }
      }
      return response;
    }catch( err) {
      throw err;
      }
    }
    async getWelfareByWelfareId(queryParams, welfareId: number, request:Request): Promise<WelfareResponseModel> {
      const response = new WelfareResponseModel();
      try {
        if (queryParams.apiVersion == 1) {
          const welfareRespone = await this.welfareRepository.findOne({
            relations:['welfarestatus','welfaretype'],
                      where:{Id:welfareId}
          });
          if (welfareRespone) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'welfare record found';
            response.intlCode = 11107;
            response.data = welfareRespone;
          } else {
            throw new ErrorResponse(99998, 'Welfare record not found');
          }
        } else {
          const welfareRespone = await this.welfareRepository.findOne({
            relations:['welfarestatus','welfaretype'],
                      where:{Id:welfareId}
          });
          if (welfareRespone) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'welfare record found';
            response.intlCode = 11107;
            response.data = welfareRespone;
          } else {
            throw new ErrorResponse(99998, 'welfare record not found');
          }
        }
        return response;
      } catch (error) {
        throw error;
      }
    }
    async getAllActiveWelfare(queryParams, request:Request): Promise<AllWelfareResponseModel> {
      const response = new AllWelfareResponseModel();
      try {
        if (queryParams.apiVersion == 1) {
          const welfare = await this.welfareRepository.find({
            relations:['welfarestatus','welfaretype'],
            where: { status: true },
            order: { createdAt: 'DESC' }
          });
          if (welfare) {
            response.status = true;
            response.data = welfare;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } else {
          const welfare = await this.welfareRepository.find({
           relations:['welfarestatus','welfaretype'],
            where: { status: true },
            order: { createdAt: 'DESC' }
          });
          if (welfare) {
            response.status = true;
            response.data = welfare;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        }
        return response;
      } catch (err) {
        throw err;
      }
    }
    async getActiveWelfareCount(queryParams, request:Request): Promise<WelfareStatusWiseResponseModel> {
      const response = new WelfareStatusWiseResponseModel();
      try {
        if(queryParams.apiVersion == 1) {
          const welfareStatusWiseCount = await getConnection()
          .createQueryBuilder()
          .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
          .from(WelfareEntity, "Welfare")
          .orderBy('status','ASC')
          .getRawOne();
          if (welfareStatusWiseCount) {
            response.status = true;
            response.active = welfareStatusWiseCount.activeCount;
            response.inActive = welfareStatusWiseCount.inActiveCount;
            response.total = welfareStatusWiseCount.cnt;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } else {
          const welfareStatusWiseCount = await getConnection()
          .createQueryBuilder()
          .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
          .from(WelfareEntity, "Welfare")
          .orderBy('status','ASC')
          .getRawOne();
          if (welfareStatusWiseCount) {
            response.status = true;
            response.active = welfareStatusWiseCount.activeCount;
            response.inActive = welfareStatusWiseCount.inActiveCount;
            response.total = welfareStatusWiseCount.cnt;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        }
        return response;
      } catch (err) {
        throw err;
      }
    }
    async updateWelfareStatus(queryParams,welfareStatusDto:WelfareStatusDTO, request:Request):Promise<WelfareResponseModel>{
      const response = new WelfareResponseModel();
      try {
        if(queryParams.apiVersion == 1) {
          await this.welfareRepository.update(welfareStatusDto.Id,welfareStatusDto);
          const welfare = await this.welfareRepository.findOne({
            //relations:['welfarestatus','welfaretype'],
            where: { Id:welfareStatusDto.Id },
          });
          if (welfare) {
            response.status = true;
            response.data = welfare;
            response.statusCode = 50000;
            response.internalMessage = 'welfare status updated successfully';
            response.intlCode = 11108;
          } else {
          throw new ErrorResponse(99998, 'welfare status update failed');
          }
        } else {
          await this.welfareRepository.update(welfareStatusDto.Id,welfareStatusDto);
          const welfare = await this.welfareRepository.findOne({
            relations:['welfarestatus','welfaretype'],
            where: { Id:welfareStatusDto.Id },
          });
          if (welfare) {
            response.status = true;
            response.data = welfare;
            response.statusCode = 50000;
            response.internalMessage = 'Welfare status updated successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'welfare status update failed');
          }
        }      
        return response;
      } catch (error) {
        throw error;
      }
    }

   
  }


